import { Link, Outlet, ScrollRestoration } from "react-router-dom"
import logoImage from "~/images/letsdogames-logo-waving-wordmark-256.png"
import { useLogout } from "~/auth/use-logout"
import { useViewer } from "~/auth/use-viewer"
import { rootPath, locationsPath, plansPath, profilePath, adminPath } from "~/common/paths"
import { User, Settings, MapPin, Calendar, LogOut, LucideIcon } from "lucide-react"
import { cn } from "~/common/cn"
import { UserRole } from "~/__generated__/graphql"

const sidebarItemStyles =
  "flex px-5 py-3 border-b border-gray-300 hover:bg-gray-100 text-sm font-medium text-gray-400 hover:text-gray-900 cursor-pointer"

const SidebarLink = ({ text, to, icon: Icon }: { text: string; to: string; icon: LucideIcon }) => (
  <Link to={to}>
    <li className={sidebarItemStyles}>
      <div className="flex items-center">
        <Icon size={18} className="text-current" />
        <div className="pl-4">{text}</div>
      </div>
    </li>
  </Link>
)

export const SidebarLinks = () => {
  const { viewer } = useViewer()

  return (
    <nav className="mt-5 border-t border-gray-300">
      <ul className="list-none flex-col">
        <SidebarLink text="Profile" to={profilePath({})} icon={User} />
        <SidebarLink text="Locations" to={locationsPath({})} icon={MapPin} />
        <SidebarLink text="Plans" to={plansPath({})} icon={Calendar} />
        {viewer.userRole === UserRole.SystemAdmin && (
          <>
            <SidebarLink text="Admin" to={adminPath({})} icon={Settings} />
          </>
        )}
      </ul>
    </nav>
  )
}

export const SidebarLayout = () => {
  const logout = useLogout()

  return (
    <div className="flex min-h-screen flex-1 grow">
      <div className="sidebar flex w-[200px] flex-col justify-between gap-2 bg-white shadow-md">
        <div>
          <Link to={rootPath({})} className="mt-5 flex">
            <img src={logoImage} alt="Let's Do Games!" className="w-auto" />
          </Link>

          <SidebarLinks />
        </div>
        <div className={cn("border-t border-gray-300", sidebarItemStyles)}>
          <button onClick={logout} className="flex w-full">
            <LogOut size={18} className="text-current" />
            <div className="pl-4">Sign Out</div>
          </button>
        </div>
      </div>

      <div className="flex max-w-full flex-1 flex-col overflow-hidden">
        <Outlet />
        <ScrollRestoration />
      </div>
    </div>
  )
}
